import React, { forwardRef } from 'react'
import { FaCode, FaIndustry ,FaLightbulb  } from "react-icons/fa";
import { FaMicrochip } from "react-icons/fa6";


const About = forwardRef(({ darkMode }, ref) => {
    
  return (
    <div ref={ref} id="about">
        <div className='container-lg my-5  about-section'>
            <div className="row mb-5">
                <div className="col-md-12 text-center ">
                    <h1 className="text-center about-header responsive-HXXtext">My <span className='highlight' style={{ color: "#c2b41e",}}>Experience</span></h1>
                </div>
            </div>
            <div className="row justify-content-center text-center gap-3">
                <div className="col-md-6 about-card d-flex align-items-center">
                    <div className='my-3'>
                    
                    <FaCode size={70}/>
                    
                    <h2 className='responsive-HXtext mt-3'>Building Interactive Web Experiences</h2>
                    <p className='responsive-Stext'>Front-End Developer | React & JavaScript Specialist</p>
            </div>
            </div>
                <div className="col-md-6 about-card d-flex align-items-center">
                    <div className='my-3'> 
                    
                    <FaIndustry size={70}/>
                    
                    <h2 className='responsive-HXtext mt-3'>Optimizing Performance at the Core</h2>
                    <p className='responsive-Stext'>Embedded Software Engineer | C/C++ & Firmware Development</p>
            </div>
            </div>
                

            </div>
            
            <div className="row mt-3 justify-content-center text-center gap-3">
                <div className="col-md-6 about-card d-flex align-items-center">
                    <div className='my-3'>
                    
                    <FaLightbulb size={70}/>
                    
                    <h2 className='responsive-HXtext mt-3'>Bridging Development & Manufacturing</h2>
                    <p className='responsive-Stext'>Production Engineer | Process Optimization & Automation</p>
            </div>
            </div>
                <div className="col-md-6 about-card d-flex align-items-center">
                    <div className='my-3'>
                    
                    <FaMicrochip size={70}/>
                    
                    <h2 className='responsive-HXtext mt-3'>Empowering Young Minds in Tech</h2>
                    <p className='responsive-Stext'>Co-Founder | Educator & Tech Mentor at <a href="https://www.facebook.com/brainwavesstemacademy/"className='nav-link d-inline' target="_blank" rel="noopener noreferrer">BW Academy</a></p>
            </div>
            </div>
                

            </div>
            
        </div>
        <div className='container-lg my-5 about-section'>
        <div className="row mb-5">
            </div>
            <div className="row justify-content-center text-center gap-2">
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={` about-skill rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/html.png' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>HTML</h2>
                    </div>

                </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/css.png' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>CSS</h2>
                    </div>
                </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/js.png' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>JS</h2>
                    </div>
                </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/react.png' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>React.js</h2>
                    </div>
                </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/framer.png' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>Framer Motion</h2>
                    </div>
                </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/next.png' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>Next.js</h2>
                    </div>
                </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/axios.webp' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>Axios</h2>
                    </div>
                </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/prisma.png' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>Prisma</h2>
                    </div>
                    </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/postgresql.png' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>Postgresql</h2>
                    </div>
                </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill  rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/reactrouter.webp' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>React Router</h2>
                    </div>
                </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill  rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/git.png' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>Git</h2>
                    </div>
                </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill  rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/github.png' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>GitHub</h2>
                    </div>
                </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill  rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/emb.png' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>Emb Systems</h2>
                    </div>
                </div>
                <div className="col-md-2 col-skill d-flex justify-content-center mb-4 ">
                    <div className={`about-skill  rounded ${darkMode ? "about-skill-bg-darkMode" : "about-skill-bg-lightMode"}`}>
                        <img src='img/py.png' className='about-skill-img d-block' alt='' />
                        <h2 className='responsive-text'>Python</h2>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
    </div>
  );
});

export default About